import { ViewLoaderInterface } from './interfaces';

export const viewLoaderInitialState: ViewLoaderInterface = {
  isOpen: true,
  message: '',
};
